import { useEffect, useRef } from 'react';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';

import config from '@/config';
import { usePrivyAccount } from '@/hooks';
import { useFingerprintTag } from '@/hooks/use-fingerprint';
import { useAccountStore } from '@/store/use-account-store';

export default function FpjsTracker() {
  const { authenticated } = usePrivyAccount();
  const { tag, primaryAddress } = useFingerprintTag();

  const { getData } = useVisitorData(
    { extendedResult: true },
    { immediate: false },
  );

  const hasIdentified = useRef<boolean>(false);

  useEffect(() => {
    if (config.isLocal || !authenticated || !tag || hasIdentified.current) {
      return;
    }

    hasIdentified.current = true;

    getData({ ignoreCache: true, tag, linkedId: primaryAddress })
      .then((data) => {
        if (data?.visitorId) {
          localStorage.setItem('fpjs_visitor_id', data.visitorId);
        }

        if (data?.requestId) {
          localStorage.setItem('fpjs_request_id', data.requestId);
          useAccountStore.getState().setFingerprintRequestId(data.requestId);
        }
      })
      .catch(() => {});
  }, [authenticated, tag, primaryAddress, getData]);

  return null;
}
